module.exports = __webpack_public_path__ + "public/SiteIcons/white-logo.png?ba743958";